import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const UserSettingsState = {
  userSettingsLoading: false,
  userSettingsSelectedModel: null,
}

export const UserSettingsActions = {
  getUserSettingsModel: async ({ commit }, id) => {
    commit('setUserSettingsLoading', true)

    return axiosRequest.get(`/admin/users/${id}`).
      then(({ data }) => {
        commit('setUserSettingsSelectedModel', data)
        return data
      }).
      catch(error => handleError(error)).
      finally(_ => commit('setUserSettingsLoading', false))
  },

  createUserSettingsModel: async ({ commit }, params) => {
    commit('setUserSettingsLoading', true)

    return axiosRequest.post('/admin/users', params).
      then(({ data }) => data.user).
      catch(error => handleError(error)).
      finally(_ => commit('setUserSettingsLoading', false))
  },

  updateUserSettingsModel: async ({ commit }, { id, params }) => {
    commit('setUserSettingsLoading', true)

    return axiosRequest.patch(`/admin/users/${id}`, params).
      then(({ data }) => data.user).
      catch(error => handleError(error)).
      finally(_ => commit('setUserSettingsLoading', false))
  },
}

export const UserSettingsMutations = {
  setUserSettingsLoading: (state, payload) => (state.userSettingsLoading = payload),
  setUserSettingsSelectedModel: (state, payload) => (state.userSettingsSelectedModel = payload),
}

export const UserSettingsGetters = {
  userSettingsLoading: state => state.userSettingsLoading,
  userSettingsSelectedModel: state => state.userSettingsSelectedModel || {},
}
